import { Spinner } from '@nike/eds';
import React from 'react';

const LoadingMessage = () => (
  <main className="ncss-col-sm-12 mt12-sm pt2-sm ta-sm-c full-height">
    <div className="d-sm-flx flx-dir-sm-c flx-ai-sm-c flx-jc-sm-c full-height">
      <Spinner size="large" />
      <p className="headline-4 pt4-sm">Please wait...</p>
    </div>
  </main>
);

export default LoadingMessage;
